import { EventSubscriber } from 'typeorm'

import { HistoryEntitySubscriber } from '@operato/typeorm-history'

import { DataSet } from '../data-set/data-set.js'
import { DataSetHistory } from './data-set-history.js'

@EventSubscriber()
export class DataSetHistoryEntitySubscriber extends HistoryEntitySubscriber<DataSet, DataSetHistory> {
  public get entity() {
    return DataSet
  }

  public get historyEntity() {
    return DataSetHistory
  }
}
